import React, { useEffect } from 'react';
import { CssBaseline as MuiCssBaseline } from '@mui/material';
import { ThemeProvider as MuiThemeProvider, useColorScheme } from '@mui/material/styles';
import GoogleAnalytics from '~/components/google/GoogleAnalytics';
import Notifications from '~/components/Notifications';
import SpinnerTw from '~/components/SpinnerTw';
import TooltipContainer from '~/components/TooltipContainer';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { CommonAppContext, useCommonAppContext, useInitCommonAppState } from '~/shared/contexts/CommonAppContext';
import StandardLayout from '~/shared/layouts/StandardLayout';
import { theme } from '~/sites/music/mui/themes';
import { getLcn } from '~/utils/labeled-classnames';
import Banner from './layout/Banner';
import SidebarContent from './layout/SidebarContent';
import { MusicAppContext, useInitMusicAppState } from '../contexts/MusicAppContext';

// nest to allow MusicAppContext to use values from the CommonAppContext
function MusicProviders({ children }: { children: React.ReactNode }) {
  const appState = useInitMusicAppState();

  return (
    <MusicAppContext.Provider value={appState}>
      <MuiThemeProvider theme={theme} defaultMode='dark'>
        {/* CssBaseline includes global CSS resets and may conflict with TW it also is responsible for light/dark mode defaults, hrm */}
        <MuiCssBaseline />
        {children}
      </MuiThemeProvider>
    </MusicAppContext.Provider>
  );
}

function Providers({ children }: { children: React.ReactNode }) {
  const commonAppState = useInitCommonAppState()

  return (
    <HelmetProvider>
      <GoogleAnalytics propertyId="G-XXX" />
      <CommonAppContext.Provider value={commonAppState}>
        <MusicProviders>
          {children}
        </MusicProviders>
      </CommonAppContext.Provider>
    </HelmetProvider>
  )
}

export default function MusicAppBase() {
  const { mode, setMode } = useColorScheme();
  const { isLoadingSessionUser } = useCommonAppContext()

  // always dark for now
  useEffect(() => {
    setMode('dark');
  }, [setMode]);

  if (isLoadingSessionUser) {
    return <SpinnerTw center={true} />;
  }
  const lcn = getLcn({
    MusicApp: '',
  });

  const mainContentStyle = {
    minHeight: `calc(100vh - 100px)`,
  }

  return (
    <Providers>
      <Helmet>
        <title>Ben Lieb's Community Song Charts for Optimal Musical Togetherness</title>
        <meta name="description" content="Music description" />
      </Helmet>

      <div className={lcn.MusicApp}>

        <div style={mainContentStyle}>
          <StandardLayout
            banner={<Banner />}
            sideBarContent={<SidebarContent />}
          />
        </div>

        <Notifications />
        <TooltipContainer />
      </div>
    </Providers>
  );
}